<template>
  <v-card style="border-radius: 10px; cursor: pointer" class="pa-0 pt-2 ma-2">
    <v-layout justify-center align-center column>
      <v-btn text @click="createDialog = true" color="primary" class="my-1">
        <v-icon>edit</v-icon> {{`Criar novo ${typeStr}`}}
      </v-btn>
      <v-menu max-height="205" top allow-overflow v-if="sortedCreators.length > 0">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text color="primary" class="my-1">
            <v-icon>person</v-icon>{{`Escolher ${typeStr}`}}
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item
              @click="creatorChosen(creator)"
              v-for="creator of sortedCreators"
              :key="creator.uid"
            >
              <v-list-item-avatar>
                <v-avatar>
                  <v-img v-if="creator.photo" :src="creator.photo" :alt="creator.name" />
                  <v-icon v-else>person</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>{{creator.name}}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-layout>
    <create-creator v-if="createDialog" v-model="createDialog" :currentCreators="creators" :type="type"/>
  </v-card>
</template>

<script>
import { creatorCollectionRef, addCreatorToContent } from "@/firebase/api/creator";
import CreateCreator from "./Create";
import CreatorMixin from "@/mixins/creatorData.js"

export default {
  components: {CreateCreator},
  mixins: [CreatorMixin],
  mounted() {
    this.$bind('creators', creatorCollectionRef(this.type))
  },

  data: () => ({
    creators: [],
    createDialog: false,
  }),
  props: {
    chosenCreators: { type: Array, required: true },
  },
  computed: {
    sortedCreators() {
      let creatorsCopy = this.creators.slice();
      creatorsCopy.sort((a, b) => a.name.localeCompare(b.name));
      creatorsCopy = creatorsCopy.filter(creator => {
        return !this.chosenCreators.some(
          chosenCreator => chosenCreator.id === creator.id
        );
      });
      return creatorsCopy;
    }
  },
  methods: {
    creatorChosen(creator) {
      addCreatorToContent(
        creator.id,
        this.$route.params.chapterID,
        this.$route.params.contentID,
        this.type
      );
    }
  },
};
</script>